/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListRiskPresetsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListRiskPresetsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListRiskPresetsSecurity = {
  option1?: ListRiskPresetsSecurityOption1 | undefined;
  option2?: ListRiskPresetsSecurityOption2 | undefined;
};

export type ListRiskPresetsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListRiskPresetsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListRiskPresetsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListRiskPresetsSecurityOption1$Outbound,
  ListRiskPresetsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listRiskPresetsSecurityOption1ToJSON(
  listRiskPresetsSecurityOption1: ListRiskPresetsSecurityOption1,
): string {
  return JSON.stringify(
    ListRiskPresetsSecurityOption1$outboundSchema.parse(
      listRiskPresetsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListRiskPresetsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListRiskPresetsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListRiskPresetsSecurityOption2$Outbound,
  ListRiskPresetsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listRiskPresetsSecurityOption2ToJSON(
  listRiskPresetsSecurityOption2: ListRiskPresetsSecurityOption2,
): string {
  return JSON.stringify(
    ListRiskPresetsSecurityOption2$outboundSchema.parse(
      listRiskPresetsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListRiskPresetsSecurity$Outbound = {
  Option1?: ListRiskPresetsSecurityOption1$Outbound | undefined;
  Option2?: ListRiskPresetsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListRiskPresetsSecurity$outboundSchema: z.ZodMiniType<
  ListRiskPresetsSecurity$Outbound,
  ListRiskPresetsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListRiskPresetsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListRiskPresetsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listRiskPresetsSecurityToJSON(
  listRiskPresetsSecurity: ListRiskPresetsSecurity,
): string {
  return JSON.stringify(
    ListRiskPresetsSecurity$outboundSchema.parse(listRiskPresetsSecurity),
  );
}

/** @internal */
export type ListRiskPresetsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListRiskPresetsRequest$outboundSchema: z.ZodMiniType<
  ListRiskPresetsRequest$Outbound,
  ListRiskPresetsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listRiskPresetsRequestToJSON(
  listRiskPresetsRequest: ListRiskPresetsRequest,
): string {
  return JSON.stringify(
    ListRiskPresetsRequest$outboundSchema.parse(listRiskPresetsRequest),
  );
}
